// extracted by mini-css-extract-plugin
export var numpadContainer = "_fp-1";
export var phoneButton = "_fp-0";